import { render } from "./CIS-Resource-PartnerListing.vue?vue&type=template&id=c015038a&scoped=true"
import script from "./CIS-Resource-PartnerListing.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-PartnerListing.vue?vue&type=script&lang=js"

import "./CIS-Resource-PartnerListing.vue?vue&type=style&index=0&id=c015038a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c015038a"]])

export default __exports__